export default __webpack_public_path__ + "static/media/exit.b2f60135.svg";